import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MobilePortraitService } from '../services/mobile-portrait.service';

export const DashboardEditDesktopGuard: CanActivateFn = route => {
  if (!inject(MobilePortraitService).isMobilePortrait()) {
    return true;
  }

  return inject(Router).createUrlTree(
    ['/dashboards', route.paramMap.get('id')],
    { queryParams: route.queryParams }
  );
};
